export function QuietPause() {
  return (
    <section
      data-testid="about-quiet-pause"
      className="relative overflow-hidden bg-[#FAFAF8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[95px] md:pt-[16px] pb-[59px] md:pb-[10px] reveal">
        <div className="max-w-[760px] text-left">
          <p className="font-display text-[37px] md:text-[59px] text-[#159E9A] leading-[1.25] mb-6">
            Some ideas simply won&rsquo;t leave you alone.
          </p>
          <div className="space-y-[13px] text-lg md:text-xl leading-[1.85] text-[#57534E]">
            <p>Blueprint4Joy was one of mine.</p>
            <p>Not because I wanted another business.</p>
            <p>
              Because I kept meeting people who were quietly successful and
              quietly wondering if there was more.
            </p>
            <p>The conversations kept repeating.</p>
            <p>Different cities. Different careers. Different stories.</p>
            <p>The same feeling.</p>
            <p>
              Somewhere along the way, &ldquo;fine&rdquo; had become good
              enough.
            </p>
            <p>I couldn&rsquo;t stop asking better questions.</p>
          </div>
          <p className="font-display text-[30px] md:text-[38px] font-medium text-[#1C1917] leading-[1.35] mt-8">
            Eventually, Blueprint4Joy became a place where we could ask them
            together.
          </p>
        </div>
      </div>
    </section>
  );
}
